import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export default function useScreenType() {
  const screens = useBreakpoint();

  return {
    isMobile: !screens.md,
    isDesktop: screens.lg,
  };
}
